import React, { Component } from 'react';
import RegistrationForm from '../forms/RegistrationForm';
import Breadcrumb from '../navs/Breadcrumb';
import Footer from '../navs/Footer';
import NavBar from '../navs/Navbar';

class Register extends Component {

    render() {
        return (
            <div>
                <NavBar />
                <Breadcrumb />
                <div>
                    <section className="portfolio-details mt-n5" style={{ padding: '20px' }}>
                        <div className="container">
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="col-md-4" data-aos="fade-up">
                                    <img src="assets/img/services/slice 6 .png" className="img-fluid" alt="" style={{ width: "18em" }} />
                                    <div className="portfolio-description">
                                        <p>Register as a client by entering your name or company name, select a service, district and area for a guaranteed response from one of our service area representatives.</p>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <section id="blog" className="blog">
                                        <div className="container-fl">
                                            <div className="row">
                                                <div className="col-lg-12  col-md-10 d-flex align-items-stretch entry" data-aos="fade-up">
                                                    <RegistrationForm />
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        )
    }


}

export default Register;
